import { render } from "./ManageBlogs.vue?vue&type=template&id=c175410a&scoped=true"
import script from "./ManageBlogs.vue?vue&type=script&lang=js"
export * from "./ManageBlogs.vue?vue&type=script&lang=js"

import "./ManageBlogs.vue?vue&type=style&index=0&id=c175410a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c175410a"]])

export default __exports__